// Типы для переводов
export interface Translations {
    common: {
        cart: string;
        search: string;
        login: string;
        register: string;
        account: string;
        home: string;
        shop: string;
        categories: string;
        product: string;
        products: string;
        price: string;
        quantity: string;
        total: string;
        addToCart: string;
        removeFromCart: string;
        checkout: string;
        loading: string;
        error: string;
        success: string;
    };
    navigation: {
        mainMenu: string;
        catalog: string;
        about: string;
        contact: string;
        blog: string;
        support: string;
    };
    cart: {
        title: string;
        empty: string;
        itemsCount: string;
        subtotal: string;
        shipping: string;
        tax: string;
        total: string;
        proceedToCheckout: string;
        goToCart: string;
        continueShipping: string;
        removeItem: string;
        updateQuantity: string;
    };
    product: {
        details: string;
        description: string;
        specifications: string;
        allSpecifications: string;
        reviews: string;
        addToWishlist: string;
        compareProducts: string;
        shareProduct: string;
        inStock: string;
        outOfStock: string;
        availability: string;
        aboutProduct: string;
        sku: string;
    };
    forms: {
        name: string;
        email: string;
        phone: string;
        password: string;
        confirmPassword: string;
        address: string;
        city: string;
        zipCode: string;
        country: string;
        save: string;
        cancel: string;
        submit: string;
        required: string;
        invalidEmail: string;
        passwordTooShort: string;
    };
    newsletter: {
        placeholder: string;
        buttonSubmit: string;
        buttonSubmitting: string;
        title: string;
        privacyText: string;
        privacyLink: string;
        successMessage: string;
        errorMessage: string;
    };
    footer: {
        title: string;
        subTitle: string;
        sections: {
            catalog: string;
            about: string;
            customer: string;
        };
        links: {
            delivery: string;
            faq: string;
        };
    };
}

// Переводы для английского языка
export const enTranslations: Translations = {
    common: {
        cart: 'Cart',
        search: 'Search',
        login: 'Login',
        register: 'Register',
        account: 'Account',
        home: 'Home',
        shop: 'Shop',
        categories: 'Categories',
        product: 'Product',
        products: 'Products',
        price: 'Price',
        quantity: 'Quantity',
        total: 'Total',
        addToCart: 'Add to Cart',
        removeFromCart: 'Remove from Cart',
        checkout: 'Checkout',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
    },
    navigation: {
        mainMenu: 'Main Menu',
        catalog: 'Catalog',
        about: 'About',
        contact: 'Contact',
        blog: 'Blog',
        support: 'Support',
    },
    cart: {
        title: 'Shopping Cart',
        empty: 'Your cart is empty',
        itemsCount: 'items in cart',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        tax: 'Tax',
        total: 'Total',
        proceedToCheckout: 'Proceed to Checkout',
        goToCart: 'Go to Cart',
        continueShipping: 'Continue Shopping',
        removeItem: 'Remove Item',
        updateQuantity: 'Update Quantity',
    },
    product: {
        details: 'Product Details',
        description: 'Description',
        specifications: 'Specifications',
        allSpecifications: 'All Specifications',
        reviews: 'Reviews',
        addToWishlist: 'Add to Wishlist',
        compareProducts: 'Compare Products',
        shareProduct: 'Share Product',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        availability: 'Availability',
        aboutProduct: 'About Product',
        sku: 'SKU',
    },
    forms: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        address: 'Address',
        city: 'City',
        zipCode: 'ZIP Code',
        country: 'Country',
        save: 'Save',
        cancel: 'Cancel',
        submit: 'Submit',
        required: 'This field is required',
        invalidEmail: 'Please enter a valid email',
        passwordTooShort: 'Password must be at least 8 characters',
    },
    newsletter: {
        placeholder: 'Enter your email',
        buttonSubmit: 'Subscribe',
        buttonSubmitting: 'Submitting...',
        title: 'Want to receive product news? Subscribe to our newsletter.',
        privacyText: 'We care about your data. Read our',
        privacyLink: 'privacy policy',
        successMessage: 'Subscription successful!',
        errorMessage: 'Error sending. Please try again.',
    },
    footer: {
        title: 'WGP Shop',
        subTitle: 'Professional e-commerce solutions and web development services',
        sections: {
            catalog: 'Catalog',
            about: 'WGP Shop',
            customer: 'For Customers',
        },
        links: {
            delivery: 'Delivery and Payment',
            faq: 'Questions and Answers',
        },
    },
};

// Переводы для русского языка
export const ruTranslations: Translations = {
    common: {
        cart: 'Корзина',
        search: 'Поиск',
        login: 'Войти',
        register: 'Регистрация',
        account: 'Аккаунт',
        home: 'Главная',
        shop: 'Магазин',
        categories: 'Категории',
        product: 'Товар',
        products: 'Товары',
        price: 'Цена',
        quantity: 'Количество',
        total: 'Итого',
        addToCart: 'В корзину',
        removeFromCart: 'Удалить из корзины',
        checkout: 'Оформить заказ',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успешно',
    },
    navigation: {
        mainMenu: 'Главное меню',
        catalog: 'Каталог',
        about: 'О нас',
        contact: 'Контакты',
        blog: 'Блог',
        support: 'Поддержка',
    },
    cart: {
        title: 'Корзина покупок',
        empty: 'Ваша корзина пуста',
        itemsCount: 'товаров в корзине',
        subtotal: 'Подытог',
        shipping: 'Доставка',
        tax: 'Налог',
        total: 'Итого',
        proceedToCheckout: 'Перейти к оформлению',
        goToCart: 'Перейти в корзину',
        continueShipping: 'Продолжить покупки',
        removeItem: 'Удалить товар',
        updateQuantity: 'Изменить количество',
    },
    product: {
        details: 'Описание товара',
        description: 'Описание',
        specifications: 'Характеристики',
        allSpecifications: 'Все характеристики',
        reviews: 'Отзывы',
        addToWishlist: 'В избранное',
        compareProducts: 'Сравнить товары',
        shareProduct: 'Поделиться товаром',
        inStock: 'В наличии',
        outOfStock: 'Нет в наличии',
        availability: 'Наличие',
        aboutProduct: 'О товаре',
        sku: 'Артикул',
    },
    forms: {
        name: 'Имя',
        email: 'Email',
        phone: 'Телефон',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        address: 'Адрес',
        city: 'Город',
        zipCode: 'Почтовый индекс',
        country: 'Страна',
        save: 'Сохранить',
        cancel: 'Отмена',
        submit: 'Отправить',
        required: 'Это поле обязательно',
        invalidEmail: 'Введите корректный email',
        passwordTooShort: 'Пароль должен содержать минимум 8 символов',
    },
    newsletter: {
        placeholder: 'Введите ваш email',
        buttonSubmit: 'Подписаться',
        buttonSubmitting: 'Отправка...',
        title: 'Хотите получать новости о продуктах? Подпишитесь на рассылку.',
        privacyText: 'Мы заботимся о ваших данных. Ознакомьтесь с нашей',
        privacyLink: 'политикой конфиденциальности',
        successMessage: 'Подписка оформлена успешно!',
        errorMessage: 'Ошибка при отправке. Попробуйте ещё раз.',
    },
    footer: {
        title: 'WGP Shop',
        subTitle: 'Профессиональные решения для электронной коммерции и веб-разработки',
        sections: {
            catalog: 'Каталог',
            about: 'WGP Shop',
            customer: 'Покупателям',
        },
        links: {
            delivery: 'Доставка и оплата',
            faq: 'Вопросы и ответы',
        },
    },
};

// Переводы для немецкого языка
export const deTranslations: Translations = {
    common: {
        cart: 'Warenkorb',
        search: 'Suchen',
        login: 'Anmelden',
        register: 'Registrieren',
        account: 'Konto',
        home: 'Startseite',
        shop: 'Shop',
        categories: 'Kategorien',
        product: 'Produkt',
        products: 'Produkte',
        price: 'Preis',
        quantity: 'Menge',
        total: 'Gesamt',
        addToCart: 'In den Warenkorb',
        removeFromCart: 'Aus Warenkorb entfernen',
        checkout: 'Zur Kasse',
        loading: 'Laden...',
        error: 'Fehler',
        success: 'Erfolgreich',
    },
    navigation: {
        mainMenu: 'Hauptmenü',
        catalog: 'Katalog',
        about: 'Über uns',
        contact: 'Kontakt',
        blog: 'Blog',
        support: 'Support',
    },
    cart: {
        title: 'Einkaufswagen',
        empty: 'Ihr Warenkorb ist leer',
        itemsCount: 'Artikel im Warenkorb',
        subtotal: 'Zwischensumme',
        shipping: 'Versand',
        tax: 'Steuer',
        total: 'Gesamt',
        proceedToCheckout: 'Zur Kasse gehen',
        goToCart: 'Zum Warenkorb',
        continueShipping: 'Weiter einkaufen',
        removeItem: 'Artikel entfernen',
        updateQuantity: 'Menge aktualisieren',
    },
    product: {
        details: 'Produktdetails',
        description: 'Beschreibung',
        specifications: 'Spezifikationen',
        allSpecifications: 'Alle Spezifikationen',
        reviews: 'Bewertungen',
        addToWishlist: 'Zur Wunschliste hinzufügen',
        compareProducts: 'Produkte vergleichen',
        shareProduct: 'Produkt teilen',
        inStock: 'Auf Lager',
        outOfStock: 'Nicht verfügbar',
        availability: 'Verfügbarkeit',
        aboutProduct: 'Über das Produkt',
        sku: 'Artikelnummer',
    },
    forms: {
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        address: 'Adresse',
        city: 'Stadt',
        zipCode: 'Postleitzahl',
        country: 'Land',
        save: 'Speichern',
        cancel: 'Abbrechen',
        submit: 'Senden',
        required: 'Dieses Feld ist erforderlich',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail ein',
        passwordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
    },
    newsletter: {
        placeholder: 'Geben Sie Ihre E-Mail ein',
        buttonSubmit: 'Abonnieren',
        buttonSubmitting: 'Wird gesendet...',
        title: 'Möchten Sie Produktneuigkeiten erhalten? Abonnieren Sie unseren Newsletter.',
        privacyText: 'Wir kümmern uns um Ihre Daten. Lesen Sie unsere',
        privacyLink: 'Datenschutzrichtlinie',
        successMessage: 'Abonnierung erfolgreich!',
        errorMessage: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    footer: {
        title: 'WGP Shop',
        subTitle: 'Professionelle E-Commerce-Lösungen und Webentwicklungsdienste',
        sections: {
            catalog: 'Katalog',
            about: 'WGP Shop',
            customer: 'Für Kunden',
        },
        links: {
            delivery: 'Versand und Zahlung',
            faq: 'Fragen und Antworten',
        },
    },
};

// Коллекция всех переводов
export const translations = {
    en: enTranslations,
    ru: ruTranslations,
    de: deTranslations,
} as const;

// Функция для получения переводов по языку
export function getTranslations(languageCode: string): Translations {
    // Используем синхронный загрузчик для клиентских компонентов
    try {
        const { getTranslationsSync } = require('./translationsLoader')
        return getTranslationsSync(languageCode)
    } catch (error) {
        // Fallback к статическим переводам
        return translations[languageCode as keyof typeof translations] || translations.en;
    }
} 
